import { ComponentInternalInstance, getCurrentInstance, reactive } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import smh from '@/renderer/scripts/smh';
import { httpUrl } from '@/renderer/scripts/http';
import user from '@/renderer/scripts/utils/user';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
export default function internalServerSettingHandler() {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const { $route } = vm;
  const initServerUrl = httpUrl.SMHUrl === 'https://' ? '' : httpUrl.SMHUrl;
  const internalServerSetting = reactive({
    url: initServerUrl,
  });
  const internalServerTestState = reactive({
    status: '',
    msg: '',
  });
  const serverUrlRules = [
    {
      required: true,
      message: i18n_t('组织机构域不能为空'),
    },
    {
      whitespace: true,
      message: i18n_t('组织机构域不能为空'),
    },
    {
      url: {
        protocols: ['http', 'https'],
      },
      require_protocol: 'true',
      message: i18n_t(' 该域名无效，请输入合法的 组织机构域'),
    },
  ];
  const methods = {
    // 暂未用到
    // initInternalServer() {
    //   internalServerSetting.url = initServerUrl;
    // },
    changeInternalServerStatus(status: 'success' | 'error' | '') {
      internalServerTestState.status = status || '';
      if (status === 'success') {
        internalServerTestState.msg = i18n_t('测试通过');
      } else if (status === 'error') {
        internalServerTestState.msg = i18n_t('验证失败，请检查网络或服务器地址 ');
      } else {
        internalServerTestState.msg = '';
      }
    },
    async testInternalServer() {
      let { url } = internalServerSetting;
      /** 兼容http://11.146.84.42/形式 */
      url = url.slice(url.length - 1) === '/' ? url.slice(0, url.length - 1) : url;
      try {
        tips.loading(i18n_t('正在验证域名，请稍后'), 0);
        const { status, data } = await smh.api.testInternalServer(url);
        tips.closeAll();
        // 利用requestId避免出现“baidu.com”这种也能通过
        if (status === 200 && typeof data?.requestId === 'string') {
          methods.changeInternalServerStatus('success');
        } else {
          methods.changeInternalServerStatus('error');
        }
      } catch (error) {
        tips.closeAll();
        methods.changeInternalServerStatus('error');
      }
    },
    async saveInternalServerSetting() {
      methods.changeInternalServerStatus('');
      let { url } = internalServerSetting;
      /** 兼容http://11.146.84.42/形式 */
      url = url.slice(url.length - 1) === '/' ? url.slice(0, url.length - 1) : url;
      httpUrl.SMHUrl = url;
      if ($route.name === 'login') {
        ipc.emit(ipc.RENDERER_EVENTS_MAP.CHANGE_SERVER_URL, internalServerSetting.url);
      } else {
        let userTokenAvailable = true;
        try {
          // 切换服务端域名后判断当前缓存的userToken是否可用
          const { organizationId } = user.getUserInfo();
          await smh.userAPI.loginOrg({
            organizationId: organizationId as number,
          });
          userTokenAvailable = true;
        } catch (e: MsgError) {
          userTokenAvailable = false;
        }
        // 非第一次修改组织机构域&userToken可用：通过跳转到refresh后回跳本页面触发刷新，相当于重新进入了一次这个页面，避免出现某些错误
        if (userTokenAvailable) {
          dispatchRouter({
            name: 'refresh',
            query: {
              ...vm.$route.query,
              lastRouteName: $route.name,
            },
          });
        }
      }
    },
  };
  return {
    internalServerSetting,
    internalServerTestState,
    serverUrlRules,
    methods,
  };
}
